import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { zoomInOnVerticalView, zoomOutOnVerticalView } from "../store/timeline";

const GANTT_CONTAINER_ID = "outer-scroll-wrapper";
const MIN_HOURS_IN_VIEW = 2;

const useZoom = () => {
  const dispatch = useAppDispatch();
  const { pixelsPerHour, pixelPerMinute } = useAppSelector(
    (state) => state.timelineSlice,
  );

  const [containerHeight, setContainerHeight] = useState(0);

  useEffect(() => {
    const el = document.getElementById(GANTT_CONTAINER_ID);
    if (!el) return;

    setContainerHeight(el.clientHeight);

    const ro = new ResizeObserver(([entry]) =>
      setContainerHeight(entry.contentRect.height),
    );
    ro.observe(el);
    return () => ro.disconnect();
  }, [pixelsPerHour]);

  const hoursCurrentlyInView =
    pixelsPerHour && containerHeight
      ? containerHeight / pixelsPerHour
      : Infinity;

  const canZoomIn = hoursCurrentlyInView > MIN_HOURS_IN_VIEW;

  const getScrollTop = (): number =>
    document.getElementById(GANTT_CONTAINER_ID)?.scrollTop ?? 0;

  const handleZoomIn = (): void => {
    dispatch(zoomInOnVerticalView(getScrollTop()));
  };

  const handleZoomOut = (): void => {
    dispatch(zoomOutOnVerticalView(getScrollTop()));
  };

  return {
    canZoomIn,
    isZoomOutDisabled: pixelPerMinute === 0.66,
    handleZoomIn,
    handleZoomOut,
  };
};

export default useZoom;
